// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__3kDln","emails":"CreateEditClinics_emails__3G7pY","emailTagLabel":"CreateEditClinics_emailTagLabel__L4ixO"};